import {
  LinearProgress,
  Link,
  Typography,
} from '@mui/material';

import { useSet } from 'hooks';

export default function SetSlot({ setCode, collection }) {
  const [set, cards] = useSet(setCode);

  if (!set) return null;

  const collected = collection.filter(card => card.collected).length;
  const completion = collected / cards.length * 100;

  return (
    <>
      <img
        src={set.icon_svg_uri}
        alt={set.name}
        style={{ width: 36, height: 36, marginRight: 8 }}
      />
      <Link href={`${setCode}`} underline="hover">
        <Typography variant="h6">
          {set.name}
        </Typography>
      </Link>
      <Typography variant="body2">
        {collected}/{cards.length}
      </Typography>
      <LinearProgress
        color="info"
        variant="determinate"
        value={completion}
      />
    </>
  );
}
